module.exports = __webpack_public_path__ + "img/fond.7b00c6c5.png";